module.exports = __webpack_public_path__ + "static/img/pi-list-checks-fill.526d0e5c.svg";